module.exports = __webpack_public_path__ + "static/media/penguin-ground.3fa0035e.png";